import { getDate } from '../admin/js/utils/utils';
import { AdminSettings, submitSetButton, registerSelectPositionFunct, registerNumFldsFunct, requiredTokenLbl } from './js/main';
// 
import '../admin/css/components/components.css';
import '../admin/css/styles-admin.css';
import '../admin/css/custom-font.css';
import { formValidationWrapp } from './js/containers/formValidationWrapp';

window.addEventListener('DOMContentLoaded', (event) => {
    // console.log(`%cHello World from ADMIN, today is ${getDate()}`, 'background: #1868c3; font-size: 16px;');
});

window.addEventListener('load', () => {
    console.log('%cADMIN has started working!!!', 'background: #1868c3; font-size: 16px;');
    submitSetButton();
    AdminSettings().load();
    registerSelectPositionFunct();
    registerNumFldsFunct();
    requiredTokenLbl();
    formValidationWrapp().init();
});